import { render, staticRenderFns } from "./VeiculoExternoEdit.vue?vue&type=template&id=fbb9f18e&"
import script from "./VeiculoExternoEdit.vue?vue&type=script&lang=js&"
export * from "./VeiculoExternoEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports